module.exports = __webpack_public_path__ + "img/itsm-header-bg.d5d32255.jpg";